import { render, staticRenderFns } from "./ClassicPaginate.vue?vue&type=template&id=b8bd302a&scoped=true"
import script from "./ClassicPaginate.vue?vue&type=script&lang=js"
export * from "./ClassicPaginate.vue?vue&type=script&lang=js"
import style0 from "./ClassicPaginate.vue?vue&type=style&index=0&id=b8bd302a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8bd302a",
  null
  
)

export default component.exports